import uniqBy from 'lodash/uniqBy';
import { isPhoneField, isEmailField, validatePhone, validateEmail } from './helpers/phoneUtils';

/**
 * This is just a temp file to handle guest field checks until we refactor it
 * PLEASE DO NOT GET COMFORTABLE WITH THIS FILE, IT'S GOING TO GO AWAY!!!!
 */

function isFieldValueValid(field, value) {
    if (!value && value !== false) {
        return !field.required;
    }
    if (isPhoneField(field.name)) {
        const error = validatePhone(value);
        // 'Phone is required.' is handled by the required check above
        return !error || error === 'Phone is required.';
    }
    if (isEmailField(field.name)) {
        return !validateEmail(value);
    }
    return true;
}

export function getBookerFieldsFromCartitems(cartItems) {
    const bookerFields =
        cartItems &&
        uniqBy(
            cartItems
                .map(e =>
                    e.tickets
                        .filter(ticket => ticket.quantity > 0)
                        .map(ticket =>
                            ticket.booking_fields.filter(
                                ({ bookerOnly }) => bookerOnly === 'booker'
                            )
                        )
                )
                .flat(2),
            e => {
                return e.id;
            }
        );
    return bookerFields;
}

export function checkBookerFieldsAreOk(booker, bookerFields, isAgent) {
    if (!bookerFields || !booker) {
        return false;
    }

    return bookerFields
        .filter(field => (field?.agentOnly && isAgent) || !field?.agentOnly)
        .every(field => {
            const value = booker[field.id];
            if (!field.required) {
                return isFieldValueValid(field, value);
            }
            return (
                value !== undefined &&
                value !== null &&
                value !== '' &&
                isFieldValueValid(field, value)
            );
        });
}

// checking every cartitem, within that every ticket, with every ticket every guest
export function checkGuestFieldsAreOk(cartItems, isAgent) {
    return cartItems.every(item =>
        item.tickets
            .filter(ticket => ticket.quantity > 0)
            .every(ticket =>
                ticket.guests.every((guest, guestIndex) => {
                    const allFieldsForThisGuest = ticket.booking_fields
                        .filter(field => (field?.agentOnly && isAgent) || !field?.agentOnly)
                        .filter(
                            ({ bookerOnly }) =>
                                bookerOnly === 'guest' ||
                                (guestIndex === 0 && bookerOnly === 'item')
                        );
                    return allFieldsForThisGuest.every(field => {
                        const value = guest?.[field.id];
                        if (!field.required) {
                            return isFieldValueValid(field, value);
                        }
                        return (
                            value !== undefined &&
                            value !== null &&
                            value !== '' &&
                            isFieldValueValid(field, value)
                        );
                    });
                })
            )
    );
}

// check if agent filled out every custom booking field
export function checkCustomBookingFieldsAreOk(cartItems) {
    return (
        cartItems.filter(cartItem => {
            return (
                cartItem.hasCustomBooking &&
                (cartItem.customBooking?.vendor_code === undefined ||
                    cartItem.customBooking?.vendor_code === null ||
                    cartItem.customBooking?.vendor_code === '')
            );
        }).length === 0
    );
}
